import styles from './CircularProgressBar.module.css'

export default function CircularProgressBar (props) {
    
    // sqSize: 100,
    // percentage: 25,
    // strokeWidth: 5
  
      // Size of the enclosing square
      let sqSize = props.sqSize;
      // SVG centers the stroke width on the radius, subtract out so circle fits in square
      let radius = (props.sqSize - props.strokeWidth) / 2;
      // Enclose cicle in a circumscribing square
      let viewBox = `0 0 ${sqSize} ${sqSize}`;
      // Arc length at 100% coverage is the circle circumference
      let dashArray = radius * Math.PI * 2;
      // Scale 100% coverage overlay with the actual percent
      let dashOffset = dashArray - dashArray * props.percentage / 100;
  
      return (
        <div >
        <svg
          className={props.percentage<0?styles.loader:''}
            width={props.sqSize}
            height={props.sqSize}
            viewBox={viewBox}>
            <circle
              className={styles.circleBackground}
              cx={props.sqSize / 2}
              cy={props.sqSize / 2}
              r={radius}
              strokeWidth={`${props.strokeWidth}px`} />
            <circle
              className={styles.circleProgress}
              cx={props.sqSize / 2}
              cy={props.sqSize / 2}
              r={radius}
              strokeWidth={`${props.strokeWidth}px`}
              // Start progress marker at 12 O'Clock
              transform={`rotate(-90 ${props.sqSize / 2} ${props.sqSize / 2})`}
              style={{
                strokeDasharray: dashArray,
                strokeDashoffset: dashOffset
              }} />
            {/* <text
              className="circle-text"
              x="50%"
              y="50%"
              dy=".3em"
              textAnchor="middle">
              {`${props.percentage}%`}
            </text> */}
        </svg>
        </div>
      );
    }
  
  
  